// import navigationRoutes from './NavigationRoutesNew'

export interface INavigationRoute {
  name: string
  displayName: string
  meta: {
    icon: string
    permissions?: string[]
    requiresAll?: string[]
    requiresAuth?: boolean
  }
  children?: INavigationRoute[]
}

const navigationRoutes = {
  root: {
    name: '/',
    displayName: 'navigationRoutes.home',
  },
  routes: [
    {
      name: 'dashboard',
      displayName: 'menu.dashboard',
      meta: {
        icon: 'vuestic-iconset-dashboard',
        permissions: ['admin_access'],
        requiresAuth: false,
      },
    },

    // PowerBI Reports - (matching your actual route)
    {
      name: 'powerbi-reports',
      displayName: 'menu.bireports',
      meta: {
        icon: 'folder_shared',
        permissions: ['admin_access'],
        requiresAuth: false,
      },
    },

    // Executive Reports (matching exec-reports route)
    {
      name: 'execheads-reports',
      displayName: 'menu.execheadreports',
      meta: {
        icon: 'folder_shared',
        permissions: ['admin_access'],
        requiresAuth: false,
      },
    },

    // Leads Reports (matching your actual route)
    {
      name: 'leads-reports',
      displayName: 'menu.leadsreports',
      meta: {
        icon: 'folder_shared',
        permissions: ['admin_access'],
        requiresAuth: false,
      },
    },

    /*
    {
      name: 'faq',
      displayName: 'menu.faq',
      meta: {
        icon: 'quiz',
      },
    },
    */
  ] as INavigationRoute[],
}

// Helper function to filter routes based on permissions
export function filterRoutesByPermissions(
  routes: INavigationRoute[],
  userPermissions: string[],
  isAuthenticated: boolean,
  isSuperUser: boolean,
): INavigationRoute[] {
  return routes
    .filter((route) => {
      // Check authentication
      if (route.meta.requiresAuth && !isAuthenticated) {
        return false
      }

      // Super users see everything
      if (isSuperUser) {
        return true
      }

      // Check permissions
      if (route.meta.permissions && route.meta.permissions.length > 0) {
        // Check if ALL permissions are required
        if (route.meta.requiresAll) {
          return route.meta.permissions.every((p) => userPermissions.includes(p))
        }
        // Check if ANY permission is sufficient
        return route.meta.permissions.some((p) => userPermissions.includes(p))
      }

      // No specific permissions required (just auth)
      return true
    })
    .map((route) => {
      // Recursively filter children
      if (route.children) {
        const filteredChildren = filterRoutesByPermissions(
          route.children,
          userPermissions,
          isAuthenticated,
          isSuperUser,
        )

        // Only include parent if it has visible children
        if (filteredChildren.length === 0) {
          return null
        }

        return {
          ...route,
          children: filteredChildren,
        }
      }
      return route
    })
    .filter(Boolean) as INavigationRoute[]
}

export default navigationRoutes
